
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signUp",
      function () {
        return require("private-next-pages/signUp.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signUp"])
      });
    }
  